export const loanCalculationRuleSet = {
  SV: [
    {
      from: 10000,
      to: 29999,
      maxMonths: 60,
      InvoiceFee: 29,
    },
    {
      from: 30000,
      to: 49999,
      maxMonths: 72,
    },
    {
      from: 50000,
      to: 69999,
      maxMonths: 108,
    },
    {
      from: 70000,
      to: 99999,
      maxMonths: 120,
    },
    {
      from: 100000,
      to: 349999,
      maxMonths: 144,
    },
    {
      from: 350000,
      to: 500000,
      maxMonths: 180,
    },
  ],
  NO: [
    {
      from: 10000,
      to: 29999,
      maxMonths: 60,
      InvoiceFee: 45,
    },
    {
      from: 30000,
      to: 49999,
      maxMonths: 72,
    },
    {
      from: 50000,
      to: 69999,
      maxMonths: 108,
    },
    {
      from: 70000,
      to: 99999,
      maxMonths: 120,
    },
    {
      from: 100000,
      to: 349999,
      maxMonths: 144,
    },
    {
      from: 350000,
      to: 500000,
      maxMonths: 180,
    },
  ],
  DK: [
    {
      from: 10000,
      to: 29999,
      maxMonths: 48,
      InvoiceFee: 0,
    },
    {
      from: 30000,
      to: 49999,
      maxMonths: 72,
    },
    {
      from: 50000,
      to: 69999,
      maxMonths: 108,
    },
    {
      from: 70000,
      to: 99999,
      maxMonths: 120,
    },
    {
      from: 100000,
      to: 349999,
      maxMonths: 144,
    },
    {
      from: 350000,
      to: 500000,
      maxMonths: 180,
    },
  ],
  FREE: [
    {
      from: 1,
      to: 99999999,
      maxMonths: 360,
    },
  ],
};
